const Select = {
	
	setup() {
		
		const selects = document.querySelectorAll('.select__input')
		
		selects.forEach(select => {
			
			// Update label on change
			select.addEventListener('change', () => Select.updateLabel(select))
			
			// Update label on initial load
			Select.updateLabel(select)
			
		})
		
	},
	
	updateLabel: select => {
		
		// Get selected option text and update label
		const label = select.closest('.select').querySelector('.select__label')
		let text = select.options[select.selectedIndex]?.text || false
		
		log({text})
		
		if (!text) text = select.options[0]?.text || ""
		
		log({text})
		
		label.textContent = text
		
		log('selected', select.options[0])
		
	},
	
}

export default Select
